import React from 'react';
import { dir } from 'i18next';

import { cn } from '@lyearn/style';
import { Divider, Stack } from '@lyearn/ui';
import { LANGUAGE_I18N_MAP_WITH_LANG_ENUM } from '@/components/LanguageMenu/consts';
import { FeatureFlags, useFeatureFlags } from '@/helper/FeatureFlags';
import ContentRecomendation from '@/modules/corporate/components/DetailPageComponents/ContentRecomendation';
import {
  ContentEntity,
  ContentRecommendationType,
  ContentRecommendationTypeEnum,
} from '@/types/schema';

import { DetailsLayoutProps } from './types';

const DetailsLayout: React.FC<DetailsLayoutProps> = ({
  sections,
  hero,
  classes,
  contentRecommendations,
  badges,
  languageType,
}) => {
  let nlpContents: ContentEntity[] = [];
  let alsContents: ContentEntity[] = [];
  contentRecommendations?.forEach((contentRecommendation: ContentRecommendationType) => {
    if (contentRecommendation.type === ContentRecommendationTypeEnum.Nlp) {
      nlpContents = contentRecommendation.contents;
    } else {
      alsContents = contentRecommendation.contents;
    }
  });

  const contents = [...nlpContents, ...alsContents];

  const { [FeatureFlags.EnableContentRecommendation]: enableContentRecommendation } =
    useFeatureFlags();
  return (
    <Stack className={classes?.root} direction="col">
      {hero ? (
        <Stack className={cn('px-0 pt-24', classes?.hero)} direction="col">
          {hero}
        </Stack>
      ) : null}
      {/* {badges?.length ? <Badges badges={badges} /> : null} */}
      <Stack
        dir={languageType ? dir(LANGUAGE_I18N_MAP_WITH_LANG_ENUM[languageType]) : undefined}
        direction="col"
        lang={languageType ? LANGUAGE_I18N_MAP_WITH_LANG_ENUM[languageType] : undefined}>
        {sections.map((section, index) => (
          <Stack key={index} className={cn('pt-56 pb-0', classes?.sections)} direction="col">
            {section}
          </Stack>
        ))}
      </Stack>
      {contents.length && enableContentRecommendation ? (
        <Stack className="pl-12" direction="col">
          <Divider className="w-full mt-12 mb-24" />
          <ContentRecomendation contents={contents} />
        </Stack>
      ) : null}
    </Stack>
  );
};

export default DetailsLayout;
